angular.module('picmonic-common').factory('User', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/user/:resource/:resource_id/:resource2',
      {
        resource: '@resource',
        resource_id: '@resource_id',
        resource2: '@resource2',
      },
      {
        getv3: {
          method: 'GET',
          url: '/api/v3/user/:resource/:resource_id/:resource2',
        },
        queryv3: {
          method: 'GET',
          url: '/api/v3/user/:resource/:resource_id/:resource2',
          isArray: true,
        },
        savev3: {
          method: 'POST',
          url: '/api/v3/user/:resource/:resource_id/:resource2',
        },
        updatev3: {
          method: 'PUT',
          url: '/api/v3/user/:resource/:resource_id/:resource2',
        },
        deletev3: {
          method: 'DELETE',
          url: '/api/v3/user/:resource/:resource_id/:resource2',
        },
        update: { method: 'PUT', isArray: false },
        post: { method: 'POST', isArray: false },
        recommended: {
          method: 'GET',
          url: '/api/v3/user/recommended',
          cancellable: true,
        },
        last_order: { method: 'GET', url: '/api/v3/user/last-order' },
        last_gb_order: { method: 'GET', url: '/api/v3/user/last-gb-order' },
        order_history: {
          method: 'GET',
          url: '/api/v3/user/order-history',
          isArray: true,
        },
        payment_info: {
          method: 'GET',
          url: '/api/v3/user/payment-info',
          isArray: false,
        },
        update_pathway: {
          method: 'PUT',
          url: '/api/v3/user/pathways/:pathway_id',
          isArray: false,
        },
        update_payment_info: {
          method: 'PUT',
          url: '/api/v3/user/payment-info',
          isArray: false,
        },
        product_access: {
          method: 'GET',
          url: '/api/v3/user/product-access',
          isArray: true,
        },
        billing_history: {
          method: 'GET',
          url: '/api/v3/user/billing-history',
          isArray: true,
        },
        can_cancel_entitlement: {
          method: 'GET',
          url: '/api/v3/user/entitlements/:users_entitlements_id/can_cancel',
        },
        queue_to_cancel_entitlement: {
          method: 'PUT',
          url: '/api/v3/user/entitlements/:users_entitlements_id/queue_to_cancel',
        },
        cancel_entitlement: {
          method: 'POST',
          url: '/api/v3/user/entitlements/:users_entitlements_id/cancel',
        },
        refund_entitlement: {
          method: 'POST',
          url: '/api/v3/user/entitlements/:users_entitlements_id/refund',
        },
        pause_entitlement: {
          method: 'POST',
          url: '/api/v3/user/entitlements/:users_entitlements_id/pause',
        },
        unpause_entitlement: {
          method: 'POST',
          url: '/api/v3/user/entitlements/:users_entitlements_id/unpause',
        },
        weakest: { method: 'GET', url: '/api/v3/user/weakest' },
        managePackages: { method: 'GET', url: '/api/v3/user/manage-packages' },
        savePackage: { method: 'POST', url: '/api/v3/user/packages' },
        removePackage: {
          method: 'DELETE',
          url: '/api/v3/user/packages/:id',
          params: { id: '@id', package_id: '@package_id' },
        },
        meta: { method: 'PUT', url: '/api/v3/user/meta/:column' },
        permissions: { method: 'GET', url: '/api/v2/user/permissions' },
        setPassword: { method: 'PUT', url: '/api/v2/user/set_password' },
        resetDemoAccount: {
          method: 'POST',
          url: '/api/v3/user/reset-demo-account',
        },
        login: {
          method: 'POST',
          url: '/api/v2/user/authenticate',
          isArray: false,
          headers: { Authorization: null },
        },
      }
    );
  },
]);
